/** Inline stroke icons in the game-UI style (no emoji, no icon font). */
const s = { fill: 'none', stroke: 'currentColor', strokeWidth: 2.6, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };
export const Back = () => <svg width="20" height="20" viewBox="0 0 24 24" {...s} aria-hidden="true"><path d="M15 5l-7 7 7 7" /></svg>;
export const Mango = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" {...s} strokeWidth={2.4} aria-hidden="true"><path d="M12 3c4 0 8 4 8 9s-4 9-8 9-8-4-8-9 4-9 8-9z" /><path d="M12 3c1-1 3-1.5 4-1" /></svg>
);
export const Camera = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" {...s} strokeWidth={2.2} aria-hidden="true"><rect x="3" y="6" width="18" height="14" rx="3" /><circle cx="12" cy="13" r="4" /><path d="M8 6l2-3h4l2 3" /></svg>
);
export const Dot = ({ on }: { on: boolean }) => (
  <span aria-hidden="true" style={{ width: 10, height: 10, borderRadius: '50%', display: 'inline-block', background: on ? '#2E9E5B' : '#E5484D', border: '2px solid #1C2033' }} />
);
